import React from 'react';
import { Modal, Form, Input, DatePicker } from 'antd';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import config from 'config';
import { IQrUser } from 'models';

dayjs.extend(utc);
dayjs.extend(timezone);

const tz = 'Europe/Moscow';
dayjs.tz.setDefault(tz);

interface Props {
    open: boolean;
    onCancel: () => void;
    onSubmit: (data: IQrUser) => void;
}

const QrCodesAddForm: React.FC<Props> = ({ open, onCancel, onSubmit }) => {
    const [form] = Form.useForm();

    const handleOk = async () => {
        try {
            const data = await form.validateFields();

            const formatted = {
                ...data,
                startDate: dayjs(data.startDate).format('DD.MM.YYYY'),
                expirationDate: dayjs(data.expirationDate).format('DD.MM.YYYY'),
            };

            onSubmit(formatted);
            form.resetFields();
        } catch (error) {
            // Валидация не прошла
        }
    };

    return (
        <Modal
            title="Создание QR-кода"
            open={open}
            onCancel={() => {
                form.resetFields();
                onCancel();
            }}
            onOk={handleOk}
            okText="Создать"
            cancelText="Отмена"
        >
            <Form
                layout="vertical"
                form={form}
                initialValues={{
                    firstName: '',
                    lastName: '',
                    email: '',
                    startDate: dayjs(),
                    expirationDate: dayjs().add(1, 'month').endOf('month'),
                }}
            >
                <Form.Item
                    name="firstName"
                    label="Имя"
                    rules={[{ required: true, message: 'Введите имя' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="lastName"
                    label="Фамилия"
                    rules={[{ required: true, message: 'Введите фамилию' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="email"
                    label="Email"
                    rules={[{ required: true, type: 'email', message: 'Введите корректный email' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item label="Дата начала" name="startDate">
                    <DatePicker
                        locale={config.ru}
                        showTime={false}
                        format={config.dates.classic}
                        style={{ width: '100%' }}
                    />
                </Form.Item>
                <Form.Item label="Дата окончания" name="expirationDate">
                    <DatePicker
                        locale={config.ru}
                        format={config.dates.classic}
                        style={{ width: '100%' }}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default QrCodesAddForm;
